import * as React from 'react';
import Radium from 'radium';
import { Link } from 'react-router-dom';

const Legal = () =>
  <div>
    <h2 style={[styles.h2, styles.base]}>Právní informace</h2>
    <Link to="/obchodni-podminky" style={styles.base}>Obchodní podmínky</Link><br />
    <Link to="/zasady-osobnich-udaju" style={styles.base}>Zásady ochrany osobních údajů</Link><br />
    <Link to="/zasady-cookies" style={styles.base}>Zásady cookies</Link>
  </div>;

const styles = {
  base: {
    color: '#FFF'
  },
  h2: {
    fontSize: '16px'
  }
};

export default Radium(Legal);



// WEBPACK FOOTER //
// ./src/browser/Feature/components/footer/legal.jsx